module.exports = __webpack_public_path__ + "static/media/limitless-logo-invert-solid.12669a19.png";